import { render } from "./EnterCorrectAnswers.vue?vue&type=template&id=16978df4&scoped=true"
import script from "./EnterCorrectAnswers.vue?vue&type=script&lang=js"
export * from "./EnterCorrectAnswers.vue?vue&type=script&lang=js"

import "./EnterCorrectAnswers.vue?vue&type=style&index=0&id=16978df4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16978df4"]])

export default __exports__